<template>
  <v-container fluid>
    <v-snackbar v-model="showMessage" top right>
      {{ message }}

      <template #action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="showMessage = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <!-- General Item Information Edit Mask -->
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>Verkaufsartikel Bearbeiten</v-card-title>
          <v-form @submit.prevent="saveItem()">
            <v-col cols="12" lg="6">
              <v-text-field
                v-model="itemForm.name"
                outlined
                label="Name"
              />
            </v-col>
            <v-col class="d-flex">
              <v-text-field
                v-model="itemForm.label"
                :rules="[
                  v => !!v || 'Pflichtfeld'
                ]"
                outlined
                class="mr-1"
                l
                label="Bezeichnung"
              />
              <v-select
                v-model="itemForm.supplier"
                :rules="[
                  v => !!v || 'Pflichtfeld'
                ]"
                outlined
                class="mx-1"
                :items="suppliers"
                return-object
                label="Hersteller"
              />
              <v-select v-model="itemForm.item_group_id" outlined class="ml-1" :items="itemGroups" item-text="name" return-object label="Gruppe" />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="itemForm.description"
                outlined
                label="Beschreibung"
              />
            </v-col>
            <v-col class="d-flex justify-end" cols="12">
              <v-btn
                type="submit"
                color="primary"
              >
                Speichern
              </v-btn>
            </v-col>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <!-- Atribute List   -->
    <!-- <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                        <v-col cols="10">
                            <v-row>
                                <v-col class="mt-5" cols="12" md="6" lg="4">
                                    Attribute Bearbeiten
                                </v-col>
                                <v-col cols="12" md="6" lg="8">
                                    <v-text-field
                                        v-model="search"
                                        label="Suche"
                                    >
                                        <v-icon slot="append">
                                            mdi-magnify
                                        </v-icon>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col class=" d-flex justify-end" cols="2">
                            <v-btn color="primary">Hinzufügen</v-btn>
                        </v-col>
                    </v-card-title>
                    <v-data-table
                        :headers="headers"
                        :items="attributes"
                        :search="search"

                    >
                        <template v-slot:[`item.actions`]="{ item }">
                            <Inertia-Link
                                :href="route('bundle.edit', item.id)"
                            >
                                <v-icon small>
                                    mdi-pencil
                                </v-icon>
                            </Inertia-Link>

                            <v-icon @click="deletePrompt(item)">
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row> -->

    <!-- Purchase Item Edit Mask -->
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>Verkaufskomponenten</v-card-title>
          <v-row>
            <v-col cols="12">
              <span class="ml-4">
                Produkte können mit Drag and Drop zugewiesen
                werden
              </span>
            </v-col>
            <v-col>
              <v-row>
                <v-col cols="12">
                  <v-expansion-panels
                    v-model="open"
                  >
                    <v-expansion-panel
                      v-for="(selectedPurchaseItem,
                              i) in selectedPurchaseItems"

                      :key="i"
                    >
                      <v-card outlined class="py-3 ma-3 ">
                        <v-expansion-panel-header>
                          {{ selectedPurchaseItem.termName }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <draggable
                            :id="selectedPurchaseItem.term_id"
                            :list="selectedPurchaseItem.items"
                            :move="checkMove"
                            group="purchaseItems"
                          >
                            <v-list-item
                              v-for="selectedPurchaseItem_2 in selectedPurchaseItem.items"
                              :key="selectedPurchaseItem_2.id"
                            >
                              <v-card
                                width="100%"
                                class=" pa-3 mb-2 rounded-0"
                              >
                                {{ selectedPurchaseItem_2.name }}
                                <v-text-field
                                  v-model="
                                    selectedPurchaseItem_2.amount
                                  "
                                  outlined
                                  label="Stückzahl"
                                  type="number"
                                />
                                <v-row>
                                  <v-col
                                    class="d-flex justify-end pt-0"
                                    cols="12"
                                  >
                                    <v-btn
                                      color="primary"
                                      @click="
                                        removePurchaseItem(
                                          selectedPurchaseItem_2,
                                          i
                                        )
                                      "
                                    >
                                      <v-icon>
                                        mdi-delete
                                      </v-icon>
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-list-item>
                          </draggable>
                        </v-expansion-panel-content>
                        <v-row>
                          <v-col class="d-flex justify-end mr-10">
                            <div v-if="i != 8">
                              Preis/Monat: {{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(monthlyPrice[i]) }}
                              Preis/Laufzeit: {{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(runtimePrice[i]) }}
                            </div>
                            <div v-else>
                              Einmaliger Preis: {{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(oneTimePrice) }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-card absolute outlined class="py-3 ma-3 ">
                <v-card-title>
                  <v-row>
                    <v-col>
                      Verfügbare Produkte
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="search"
                        class="pt-0 mt-0"
                        label="Suche"
                      />
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-list
                  height="600px"
                  class="overflow-y-auto"
                >
                  <v-divider class="mb-4" />

                  <draggable

                    :list="searchableList"
                    :group="{
                      name: 'purchaseItems',
                      pull: 'clone',
                      put: false
                    }"
                    :move="checkMove"
                  >
                    <v-list-item
                      v-for="availablePurchaseItem in searchableList"
                      :key="availablePurchaseItem.id"
                    >
                      <v-card
                        width="100%"
                        class="pa-3 mb-2 rounded-0"
                      >
                        {{ availablePurchaseItem.name }}
                      </v-card>
                    </v-list-item>
                  </draggable>
                </v-list>
              </v-card>
            </v-col>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                class="ma-3"
                color="primary"
                @click="submitPurchaseItems()"
              >
                Speichern
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
import draggable from 'vuedraggable'
import axios from 'axios'

export default {
   name: 'ItemIndex',
   metaInfo () {
      return {
         title: this.title ? this.title : `Verkaufsartikel - ${this.item.product_name} ${this.item.name}`
      }
   },
   components: {
      draggable
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      purchaseItems: {
         type: Object,
         required: true
      },
      item: {
         type: Object,
         required: true
      },
      itemGroups: {
         type: Array,
         required: true
      },
      suppliers: {
         type: Array,
         required: true
      }
   },
   data () {
      return {
         itemForm: this.$inertia.form({
            name: this.item.name,
            description: this.item.description,
            item_group_id: this.item.item_group_id,
            label: this.item.label,
            supplier: this.item.supplier
         }),
         selectedPurchaseItems: this.purchaseItems.selected,
         availablePurchaseItems: this.purchaseItems.available,
         headers: [
            { text: 'Name', value: 'name' },
            { text: 'Wert', value: 'value' },
            { text: 'Erstellungsdatum', value: 'created_at' },
            { text: '', value: 'actions', sortable: false }
         ],
         showMessage: false,
         message: null,
         search: '',
         open: 0,
      }
   },
   computed: {
      searchableList () {
         return this.availablePurchaseItems.filter(purchaseItem => {
            return purchaseItem.name.toLowerCase().includes(this.search.toLowerCase())
         })
      },
      monthlyPrice: function () {
         const returnVal = {}
         for (const [key, element] of Object.entries(this.selectedPurchaseItems)) {
            if (key === 8) {
               continue
            }
            returnVal[key] = 0.00
            element.items.forEach(item => {
               item.terms.forEach(term => {
                  if (term.id === parseInt(key)) {
                     returnVal[key] = (parseFloat(returnVal[key]) + (parseFloat(term.price)).toFixed(2) * item.amount)
                  }
               })
            })
         }
         return returnVal
      },
      runtimePrice: function () {
         const returnVal = {}
         for (const [key, element] of Object.entries(this.monthlyPrice)) {
            if (parseInt(key) === 8) {
               returnVal[key] = element
            }
            if (parseInt(key) === 2) {
               returnVal[key] = element * 36
            }
            if (parseInt(key) === 3) {
               returnVal[key] = element * 60
            }
         }
         return returnVal
      },
      oneTimePrice: function () {
         let price = 0

         this.selectedPurchaseItems[8].items.forEach(item => {
            price += item.price * item.amount
         })

         return price.toFixed(2) + '€'
      },

   },
   methods: {
      clone: function (el) {
         return {
            name: el.name + ' cloned'
         }
      },
      checkMove: function (evt) {
         let returnVal = false
         evt.draggedContext.element.terms.every(element => {
            if (element.id === evt.relatedContext.component.$attrs.id) {
               evt.draggedContext.element.term_id = element.id
               evt.draggedContext.element.price = element.price
               returnVal = true
               return false
            }
            return true
         })
         if (returnVal) {
            if (evt.relatedContext.list === null) {
               returnVal = true
            } else {
               evt.relatedContext.list.forEach(element => {
                  if (evt.draggedContext.element.name === element.name) {
                     this.message = 'Eintrag schon vorhanden'
                     this.showMessage = true
                     returnVal = false
                  }
               })
            }
         } else {
            this.message =
                    'Dieser Artikel ist für die ausgewählte Laufzeit nicht zulässig'
            this.showMessage = true
            returnVal = false
         }
         return returnVal
      },
      removePurchaseItem (selectedItem, id) {
         for (let [key, element] of Object.entries(
            this.selectedPurchaseItems
         )) {
            if (key === id) {
               for (key in element.items) {
                  if (element.items[key].id === selectedItem.id) {
                     element.items.splice(key, 1)
                  }
               }
            }
         }
      },
      submitPurchaseItems () {
         axios
            .post(
               this.route('item.update_purchase_item_table', this.item.id),
               this.selectedPurchaseItems
            )
            .then(response => console.log(response))
      },
      saveItem () {
         this.itemForm.patch(this.route('item.update', this.item.id))
      }
   }
}
</script>

<style></style>
